// Pointy-top hexes of circumradius 1 in world units, matching the
// simulation's axial (q, r) coordinates and ferro-viz's renders.

export const SQRT3 = Math.sqrt(3);
/** Centre-to-edge distance. */
export const APOTHEM = SQRT3 / 2;

export function hexX(q: number, r: number): number {
  return SQRT3 * (q + r / 2);
}

export function hexY(r: number): number {
  return 1.5 * r;
}

/** The hex containing world point (x, y), as [q, r]. */
export function hexAt(x: number, y: number): [number, number] {
  const qf = (SQRT3 / 3) * x - y / 3;
  const rf = (2 / 3) * y;
  const sf = -qf - rf;
  let q = Math.round(qf);
  let r = Math.round(rf);
  const s = Math.round(sf);
  const dq = Math.abs(q - qf);
  const dr = Math.abs(r - rf);
  const ds = Math.abs(s - sf);
  if (dq > dr && dq > ds) q = -r - s;
  else if (dr > ds) r = -q - s;
  return [q, r];
}

export function hexDistance(q1: number, r1: number, q2: number, r2: number): number {
  const dq = q1 - q2;
  const dr = r1 - r2;
  return (Math.abs(dq) + Math.abs(dr) + Math.abs(dq + dr)) / 2;
}

/** Where units sit inside a hex, by how many share it (world-unit offsets). */
export const SLOTS: ReadonlyArray<ReadonlyArray<readonly [number, number]>> = [
  [],
  [[0, 0]],
  [
    [-0.36, 0],
    [0.36, 0],
  ],
  [
    [-0.36, -0.26],
    [0.36, -0.26],
    [0, 0.36],
  ],
  [
    [-0.34, -0.32],
    [0.34, -0.32],
    [-0.34, 0.32],
    [0.34, 0.32],
  ],
];

export function slot(index: number, count: number): readonly [number, number] {
  if (count < SLOTS.length) return SLOTS[count][index] ?? [0, 0];
  const a = (index / count) * Math.PI * 2;
  return [Math.cos(a) * 0.5, Math.sin(a) * 0.5];
}
